<template>
  <div class="form-group bs-form-group">
    <label v-if="label" :for="name" class="text-uppercase mb-0">{{ label }}</label>
    <datepicker
        class="bs-date form-control p-0 text-dark shadow-sm border-top-0 border-left-0 border-bottom-1"
        :class="cal"
        :format="(format ? format : 'D dsu MMM, yyyy')"
        :disabled-dates="disabled"
        :minimum-view="minimumView"
        @closed="$emit('closed')"
        v-model="inputValue"></datepicker>
    <small class="form-text text-danger" v-if="error && error[name]">{{ error[name][0] }}</small>
    <small class="form-text text-muted" v-else-if="help">{{ help }}</small>
  </div>

</template>

<script>
import { DateTime } from 'luxon'

export default {
  name: 'BSDate',
  props: ['label', 'name', 'help', 'error', 'minimumView', 'format', 'disabledDates', 'value', 'cal'],
  computed: {
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', DateTime.fromJSDate(val).toISODate())
      }
    },
    disabled () {
      if (this.disabledDates) return this.disabledDates
      else {
        return { to: DateTime.local().minus({ months: 1 }).endOf('month').toJSDate() }
      }
    }
  }
}
</script>

<style lang="scss">
.bs-date {

  input {
    font-size: 1rem;
    padding: 0.3775rem 0.75rem;
    transition: all 0.15s ease;
    border-radius: 0.25rem;
    border: none;
    width: 100%;
    cursor: pointer;
    font-weight: 400;

    &:focus {
      outline: none;
    }
  }

  .vdp-datepicker__calendar {
    position: fixed;
  }

  &.btn-info {
    font-weight: 700;

    &.vdp-datepicker {
      background: none;
    }
  }

  &.right {

    .vdp-datepicker__calendar {
      position: absolute;
      right: 0;
    }
  }
}
</style>
